import { AT } from '../../../actions/actionTypes';
import { Activity, InfoState, View } from './model';
import { ErrorDataResponse, ReduxState } from '../../../interfaces';
import useDispatcher from '../../../hooks/useDispatcher';
import { useSelector } from 'react-redux';
import { TransferDialogs } from './consts';
import { Modals, Panels } from '../model';
import useDevices from '../../../components/devicesPage/useDevices';
import useDialog from '../../../components/shared/dialog/useDialog';
import * as MyKeysApiTransfer from '../../../core/apis/mykeys/transfer';
import { MyKeysPromiseMap } from '../../../core/apis/mykeys/mappings';
import useCallStatus from '../../../hooks/useCallStatus';
import * as m from './messages';
import { PKey } from '../../devices';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

export const useTx = () => {
  const state = useSelector((s: ReduxState) => s.dialogState.transferState);
  const { doAction } = useDispatcher();
  const { setDialog } = useDialog();
  const { refreshData } = useDevices(); 

  const getDetailsCall = useCallStatus();

  const openTxDialog = () => {
    Logger.info(['openTransferDialog'], LogArea.Redux);
    setDialog?.(Panels.DEVICE_TRANSFER);
  };

  const changeScreen = (screen: TransferDialogs) => {
    const payload: View = { screen };
    doAction<View>(AT.DIALOG_TRANSFER_SETMODE, payload);
    openTxDialog();
  };

  const getDevices = (transferId: number) => {
    MyKeysApiTransfer.getTxDetails(transferId)
      .then(MyKeysPromiseMap)
      .then((data: Activity) => {
        const payload = { transferId, devices: data.devices };
        doAction<InfoState>(AT.DIALOG_TRANSFER_DEVICES_CHANGED, payload);
        getDetailsCall.success();
      })
      .catch((err: ErrorDataResponse) => {
        let errMsg = m.msgGetDetailsTxError;
        getDetailsCall.error(errMsg);
      });
    getDetailsCall.fetch();
  };

  const showTxDevices = (transferId?: number, devices: PKey[] = []) => {
    doAction<InfoState>(AT.DIALOG_TRANSFER_DEVICES_CHANGED, { transferId, devices });
    doAction<Modals>(AT.MODAL_ACTIVE_CHANGED, Modals.TRANSFER_DEVICES);
  };

  const closePanel = () => {
    setDialog?.();
  };

  return {
    screen: state.screen,
    send: state.send,
    request: state.request,
    info: state.info,
    changeScreen,
    showTxDevices,
    closePanel,
    refreshData,
    getDevices,
    getDevicesStatus: getDetailsCall.status,
  };
};

export default useTx;
